var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 15.8334H4.16667C3.72464 15.8334 3.30072 15.6578 2.98816 15.3452C2.67559 15.0326 2.5 14.6087 2.5 14.1667V5.83335M2.5 5.83335C2.5 5.39133 2.67559 4.9674 2.98816 4.65484C3.30072 4.34228 3.72464 4.16669 4.16667 4.16669H15.8333C16.2754 4.16669 16.6993 4.34228 17.0118 4.65484C17.3244 4.9674 17.5 5.39133 17.5 5.83335M2.5 5.83335L10 10.8334L17.5 5.83335M17.5 5.83335V10.8334M12.5 15.8334L14.1667 17.5L17.5 14.1667",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCheck);
export default __webpack_public_path__ + "static/media/mailCheck.0777af9e0474a7df9fe43de08ed2ce71.svg";
export { ForwardRef as ReactComponent };